import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleLabel: {
        id: 'cep.components.sgSpmRenewalSummary.VehicleLabel',
        defaultMessage: 'Vehicle:'
    },
    DriversLabel: {
        id: 'cep.components.sgSpmRenewalSummary.DriversLabel',
        defaultMessage: 'Driver(s):'
    },
    CSDLabel: {
        id: 'cep.components.sgSpmRenewalSummary.CSDLabel',
        defaultMessage: 'Policy start date:'
    },
    CoverLabel: {
        id: 'cep.components.sgSpmRenewalSummary.CoverLabel',
        defaultMessage: 'Cover level:'
    },
    MakeChangesLabel: {
        id: 'cep.components.sgSpmRenewalSummary.MakeChangesLabel',
        defaultMessage: 'Want to make a change to your renewal?'
    },
    MakeChangesLink: {
        id: 'cep.components.sgSpmRenewalSummary.MakeChangesLink',
        defaultMessage: 'Make changes'
    },
    CoverYearLabel: {
        id: 'cep.components.sgSpmRenewalSummary.CoverYearLabel',
        defaultMessage: 'Cover year:'
    },
    CoverYearInfo: {
        id: 'cep.components.sgSpmRenewalSummary.CoverYearInfo',
        defaultMessage: '{startDate} - {endDate}'
    },
});
